<app-login-card>
  @if (isLinkNotValid) {
    <div class="row form-row">
      <div class="col-md-12">
        <h1 class="text-center">{{ 'oauth_link_not_valid_heading' | translate }}</h1>
      </div>
    </div>
    <div class="row form-row">
      <div class="col-12">
        <ds-banner [state]="DsBannerState.error" data-test-id="oauth-organization-link-not-valid">
          <div ds-banner-body>{{ 'oauth_link_not_valid' | translate }}</div>
        </ds-banner>
      </div>
    </div>
  } @else {
    <form name="form" (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="row form-row">
        <div class="col-md-12">
          <h1 class="text-center">{{ 'oauth_organization_heading' | translate }}</h1>
        </div>
      </div>
      @if (details) {
        <div class="row form-row">
          <div class="col-12">
            <p data-test-id="oauth-organization-client">{{ 'oauth_organization_client' | translate: details.clientName }}</p>
            <p data-test-id="oauth-organization-returns-to">
              {{ 'oauth_organization_returns_to' | translate: details.redirectHost }}
            </p>
          </div>
        </div>
      }
      <div class="row form-row">
        <div class="col-12">
          <ds-input
            [label]="'organization_url' | translate"
            [instructions]="'oauth_organization_hint' | translate"
            [errorMessage]="formFieldErrors[FormField.organizationUrl]"
            [errorState]="formFieldErrors[FormField.organizationUrl]?.length > 0"
            [required]="true"
          >
            <input
              #organizationInput
              ds-input-field
              type="text"
              autocomplete="off"
              autocapitalize="none"
              spellcheck="false"
              [placeholder]="'oauth_organization_url_placeholder' | translate"
              [formControlName]="FormField.organizationUrl"
              data-test-id="oauth-organization-input"
            />
          </ds-input>
        </div>
      </div>
      @if (submitError) {
        <div class="row form-row">
          <div class="col-12">
            <ds-banner [state]="DsBannerState.error" data-test-id="oauth-organization-submit-error">
              <div ds-banner-body>{{ submitError }}</div>
            </ds-banner>
          </div>
        </div>
      }
      <div class="row margin-bottom">
        <div class="col-md-12 d-flex justify-content-center">
          <button
            ds-button
            type="submit"
            [variant]="DsButtonVariants.primary"
            [disabled]="isSubmitting"
            data-test-id="oauth-organization-continue-btn"
          >
            {{ 'label_continue' | translate }}
          </button>
        </div>
      </div>
    </form>
  }
</app-login-card>
